// Configurações do backend
export const BACKEND_CONFIG = {
  // URL base do backend (apenas para autenticação e usuários)
  BASE_URL: process.env.REACT_APP_BACKEND_URL || 'https://backendconsultabitrix.villelaintegra.com.br',
  
  // Endpoints da API
  ENDPOINTS: {
    AUTH: {
      LOGIN: '/api/auth/login',
      REGISTER: '/api/auth/register',
      REFRESH: '/api/auth/refresh',
      LOGOUT: '/api/auth/logout',
      PROFILE: '/api/auth/profile'
    },
    USERS: {
      LIST: '/api/users',
      GET: '/api/users/:id',
      CREATE: '/api/users',
      UPDATE: '/api/users/:id',
      DELETE: '/api/users/:id'
    },
    STATUS: '/api/status',
    HEALTH: '/health'
  },
  
  // Configurações de timeout
  TIMEOUT: {
    REQUEST: 10000, // 10 segundos
    REFRESH: 5000   // 5 segundos
  },
  
  // Configurações de retry
  RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 1000 // 1 segundo
  }
};

// Função para construir URLs completas
export const buildUrl = (endpoint, params = {}) => {
  let url = `${BACKEND_CONFIG.BASE_URL}${endpoint}`;
  
  // Substituir parâmetros na URL
  Object.keys(params).forEach(key => {
    url = url.replace(`:${key}`, params[key]);
  });
  
  return url;
};

// Função para fazer requisições HTTP com retry
export const fetchWithRetry = async (url, options = {}, retryCount = 0) => {
  try {
    const response = await fetch(url, options);
    return response;
  } catch (error) {
    if (retryCount < BACKEND_CONFIG.RETRY.MAX_ATTEMPTS) {
      console.log(`Tentativa ${retryCount + 1} falhou, tentando novamente em ${BACKEND_CONFIG.RETRY.DELAY}ms...`);
      await new Promise(resolve => setTimeout(resolve, BACKEND_CONFIG.RETRY.DELAY));
      return fetchWithRetry(url, options, retryCount + 1);
    }
    throw error;
  }
};
